<template>
  <b-card
    :title="title"
    :img-src="imageSource"
    img-alt="Image"
    img-top
    tag="article"
    style="max-width: 20rem;"
    class="payment mb-2"
  >
    <b-card-text class="text">
      {{ description }}
    </b-card-text>

    <div class="buttons">
      <b-btn
        href="#payment-form"
        class="button"
        v-on:click="purchase"
        size="med"
        pill
        variant="primary"
        style="font-size: 1.5em; color: white; font-weight: bold; padding: 0vw 1vw; align-self: center;"
        >Buy</b-btn
      >
    </div>

    <h5>{{ credits }} Credits</h5>
    <h5>
      <strong
        >Price:
        {{
          price.toLocaleString("en-US", { style: "currency", currency: "USD" })
        }}
      </strong>
    </h5>
  </b-card>
</template>

<script>
import { getInstance } from "@/auth/index";

export default {
  name: "PaymentCard",

  methods: {
    purchase: function(event) {
      if (this.$auth.isAuthenticated) {
        // Case 1: User is authenticated - we want them to be able to pay without verifying
        this.$emit("purchase-credits", {
          packageName: this.title,
          priceID: this.priceID
        });
      } else {
        // Case 3: User is not authenticated
        const authService = getInstance();
        authService.loginWithRedirect({ appState: { targetUrl: "/pricing" } });
      }
    }
  },

  props: {
    credits: {
      required: true,
      type: Number
    },

    description: {
      required: true,
      type: String
    },

    imageSource: {
      required: true,
      type: String
    },

    modal: {
      required: true,
      type: String
    },

    price: {
      required: false,
      type: Number
    },

    title: {
      required: true,
      type: String
    },

    UUID: {
      required: true,
      type: String
    }
  }
};
</script>

<style scoped>
.payment {
  margin: 1rem;
  max-width: 40rem;
  justify-items: center;
}

.payment:hover {
  opacity: 80;
}

.text {
  min-height: 8rem;
}

.button {
  margin: 1rem 1rem 1rem 1rem;
  font-size: 1em;
  font-weight: 600;
}
</style>
